<script lang="ts" setup>
	import {cn} from '@/scripts/utils/utils';
	import {X} from 'lucide-vue-next';
	import {
		DialogClose,
		DialogContent,
		type DialogContentEmits,
		type DialogContentProps,
		DialogOverlay,
		DialogPortal,
		useForwardPropsEmits,
	} from 'radix-vue';
	import {computed, type HTMLAttributes} from 'vue';
	import {type SheetVariants, sheetVariants} from '.';

	interface SheetContentProps extends DialogContentProps {
		class?: HTMLAttributes['class'];
		side?: SheetVariants['side'];
	}

	const props = defineProps<SheetContentProps>();

	const emits = defineEmits<DialogContentEmits>();

	defineOptions({
		inheritAttrs: false,
	});

	const delegatedProps = computed(() => {
		const {class: _, side: __, ...delegated} = props;

		return delegated;
	});

	const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
	<DialogPortal>
		<DialogOverlay
			class="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/80"
		/>
		<DialogContent
			:class="cn(sheetVariants({side}), props.class)"
			v-bind="{...forwarded, ...$attrs}"
		>
			<slot />

			<DialogClose
				class="ring-offset-background focus:ring-ring data-[state=open]:bg-secondary absolute top-4 right-4 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none"
			>
				<X class="text-muted-foreground h-4 w-4" />
			</DialogClose>
		</DialogContent>
	</DialogPortal>
</template>
